import { render } from "./BaseRank.vue?vue&type=template&id=0655d828"
import script from "./BaseRank.vue?vue&type=script&lang=js"
export * from "./BaseRank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__